import React, { FC, useEffect, useState } from 'react';
import { SplitFactory, withSplitFactory } from '@splitsoftware/splitio-react';

import { SplitLocalStorageEventsSender } from './lib/splitio/SplitLocalStorageEventsSender';

// App component is an entrypoint to React tree
// Wrapped in SplitFactory component; all its descendants have access to the split.io SDK functionality

type AppComponentProps = {
  children?: JSX.Element;
};

const AppComponent: FC<AppComponentProps> = ({ children }) => {
  const [splitFactory, setSplitFactory] = useState(window.splitFactory);

  useEffect(() => {
    window.addEventListener('split_initialized', () => {
      setSplitFactory(window.splitFactory);
    });
  }, []);

  if (splitFactory) {
    return (
      <SplitFactory factory={splitFactory}>
        <SplitLocalStorageEventsSender>
          {children}
        </SplitLocalStorageEventsSender>
      </SplitFactory>
    );
  }

  return <>{children}</>;
};

export const App = window.splitFactory
  ? withSplitFactory(undefined, window.splitFactory)(AppComponent)
  : AppComponent;
